// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__1N1bW","loaderOuter":"PageOverlayLoader_loaderOuter__31riS"};